// Redux
import { Dispatch } from "redux";

// Classes
import {
  VisitorTypeReducerState,
  ProspectTree
} from "../classes/visitorType.classes";

// Action Creators
import {
  setProspectiveStudents,
  setParentsOfProspects,
  setCurrentStudent,
  setAlumni,
  setFaculty,
  setGuidanceCounselor,
  setVeteran,
  setVisitorTypeState
} from "../actionCreators/visitorType.actionCreators";

const modifyProspectTree = (prevTree: ProspectTree, key: string) => {
  const newProspectTree = { ...prevTree };
  newProspectTree[key] = !newProspectTree[key];

  if (key === "hsStudent") {
    if (newProspectTree[key]) {
      newProspectTree.hsFreshman = true;
      newProspectTree.hsSophomore = true;
      newProspectTree.hsJunior = true;
      newProspectTree.hsSenior = true;
    } else {
      newProspectTree.hsFreshman = false;
      newProspectTree.hsSophomore = false;
      newProspectTree.hsJunior = false;
      newProspectTree.hsSenior = false;
    }
  } else if (
    key === "hsFreshman" ||
    key === "hsSophomore" ||
    key === "hsJunior" ||
    key === "hsSenior"
  ) {
    if (
      newProspectTree.hsFreshman &&
      newProspectTree.hsSophomore &&
      newProspectTree.hsJunior &&
      newProspectTree.hsSenior
    ) {
      newProspectTree.hsStudent = true;
    } else if (
      newProspectTree.hsFreshman ||
      newProspectTree.hsSophomore ||
      newProspectTree.hsJunior ||
      newProspectTree.hsSenior
    ) {
      newProspectTree.hsStudent = undefined;
    } else {
      newProspectTree.hsStudent = false;
    }
  }

  return newProspectTree;
};

export const setProspectiveStudentsValue = (
  dispatch: Dispatch<any>,
  value: ProspectTree,
  key: string
) => {
  dispatch(setProspectiveStudents(modifyProspectTree(value, key)));
};

export const setParentsOfProspectsValue = (
  dispatch: Dispatch<any>,
  value: ProspectTree,
  key: string
) => {
  dispatch(setParentsOfProspects(modifyProspectTree(value, key)));
};

export const setCurrentStudentValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setCurrentStudent(value));
};

export const setAlumniValue = (dispatch: Dispatch<any>, value: boolean) => {
  dispatch(setAlumni(value));
};

export const setFacultyValue = (dispatch: Dispatch<any>, value: boolean) => {
  dispatch(setFaculty(value));
};

export const setGuidanceCounselorValue = (
  dispatch: Dispatch<any>,
  value: boolean
) => {
  dispatch(setGuidanceCounselor(value));
};

export const setVeteranValue = (dispatch: Dispatch<any>, value: boolean) => {
  dispatch(setVeteran(value));
};

export const initializeVisitorTypeState = (
  dispatch: Dispatch<any>,
  state: VisitorTypeReducerState
) => {
  dispatch(setVisitorTypeState(state));
};
